export default __webpack_public_path__ + "static/media/screen7.ab6c0985.png";